var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerMedallion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.999,
    height: 71.078,
    viewBox: "0 0 49.999 71.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31923",
    "data-name": "Rectangle 31923",
    width: 49.999,
    height: 71.078,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40664",
    "data-name": "Path 40664",
    d: "M87.73,132.715A24.978,24.978,0,0,0,124.9,99.337a25.536,25.536,0,0,0-1.861-1.867L87.73,132.72Z",
    transform: "translate(-87.73 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40665",
    "data-name": "Path 40665",
    d: "M86.45,114.733a19.83,19.83,0,1,0,19.825-20.3,20.07,20.07,0,0,0-19.825,20.3",
    transform: "translate(-86.45 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partner-medallion",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M116.315,50.26,106.77,68.434h14.1l9.656-18.174H116.321Z",
    transform: "translate(-89.226 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14172",
    "data-name": "Group 14172",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 15.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M119.843,77.38h-2.094a.659.659,0,0,0-.659.659h0v1.593a1.006,1.006,0,0,1-1.009,1.009h-12.2a1.006,1.006,0,0,1-1.009-1.009h0V78.039a.659.659,0,0,0-.659-.659h-2.27a.651.651,0,0,0-.63.467L96.36,87.4h27.077l-2.952-9.556a.664.664,0,0,0-.63-.467",
    transform: "translate(-84.89 -77.38)",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M101.7,86.44a25,25,0,0,0-18.57,41.738l35.309-35.309A24.884,24.884,0,0,0,101.7,86.44",
    transform: "translate(-76.7 -81.154)",
    fill: "#cecdcc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(6.435 27.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14173",
    "data-name": "Group 14173",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 46.394,
    height: 46.365,
    fill: "#d3d3d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14174",
    "data-name": "Group 14174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(4.667 25.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M105.038,94.43a20.3,20.3,0,1,1-20.338,20.3,20.3,20.3,0,0,1,20.338-20.3h0",
    transform: "translate(-84.7 -94.43)",
    fill: "#999898"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(5.688 25.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14175",
    "data-name": "Group 14175",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 39.655,
    height: 40.606,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14176",
    "data-name": "Group 14176",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(6.75 0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M113.684,68.459h-14.1L88.27,50.32h14.323Z",
    transform: "translate(-88.27 -50.32)",
    fill: "#57a932"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40666",
    "data-name": "Path 40666",
    d: "M110.849,135.132l-6.1-10.566L98.65,114h24.4l-6.1,10.566-6.1,10.566Z",
    transform: "translate(-85.845 -76.813)",
    fill: "#489835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40667",
    "data-name": "Path 40667",
    d: "M111.962,134.466l-5.566-9.638-5.566-9.638h22.258l-5.566,9.638-5.56,9.638Z",
    transform: "translate(-86.753 -77.308)",
    fill: "#5cac33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMedallion);
export default __webpack_public_path__ + "static/media/Partner-medallion.f4fe5d326f3e204800bfa29c2e47b56d.svg";
export { ForwardRef as ReactComponent };